import { Burger } from "./components/burger.js";
import { animateOnScroll } from "./components/animated-on-scroll.js";

// document.addEventListener("DOMContentLoaded", () => {

	// Global vars
	const $body = document.body;
	animateOnScroll.init();
	Burger;

	/**
	 * HEADER
	 */
	// Get Header Height
	const $siteHeader = document.querySelector("#siteHeader");

	if (typeof $siteHeader != "undefined" && $siteHeader != null) {
		const offsetSiteHeader = () => {
			let siteHeaderHeight = $siteHeader.getBoundingClientRect().height;
			$body.style.setProperty("--_header_h", `${siteHeaderHeight}px`);
		};

		offsetSiteHeader();
		window.addEventListener("resize", offsetSiteHeader, false);
	}

	// Initial state
	window.addEventListener("scroll", function () {
		document.body.classList.toggle("show-sticky-burger", window.scrollY > $siteHeader.getBoundingClientRect().top + $siteHeader.offsetHeight);
	});

	// Bleed elements
	const $bleedBanner = document.querySelectorAll("[data-bleed]");
	if (typeof $bleedBanner != "undefined" && $bleedBanner != null) {
		const offsetBleedBanner = () => {
			$bleedBanner.forEach((banner) => {
				let offset = banner.getBoundingClientRect().left;
				banner.style.setProperty("--_bleed-x", `-${offset}px`);
			});
		};

		offsetBleedBanner();
		window.addEventListener("resize", offsetBleedBanner, false);
	}

	// Offset left
	const $pushLeftCtns = document.querySelectorAll("[data-push-left]");
	if ($pushLeftCtns.length) {
		const pushLeft = () => {
			$pushLeftCtns.forEach((ctn) => {
				let offset = ctn.querySelector(".container").getBoundingClientRect().left;
				ctn.style.setProperty("--_push-x", `${offset}px`);
			});
		};
		pushLeft();
		window.addEventListener("resize", pushLeft, false);
	}

	// Menu mobile
	if (window.matchMedia("(max-width: 799.98px)").matches) {
		let subnav_trigger = document.querySelectorAll(".nav-panel__trigger");
		if (subnav_trigger) {
			subnav_trigger.forEach((trigger) => {
				trigger.addEventListener("click", (e) => {
					let panel = e.currentTarget.parentElement;

					if (panel.classList.contains("is-open")) {
						panel.classList.remove("is-open");
					} else {
						document.querySelectorAll(".nav-panel").forEach((child) => {
							child.classList.remove("is-open");
						});
						panel.classList.add("is-open");
					}
				});
			});
		}
	}

	const langSwitcher = document.querySelector(".lang-switcher");
	if (langSwitcher) {
		langSwitcher.addEventListener("click", (e) => {
			langSwitcher.classList.toggle("is-open");
		});
	}
// });
